module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_c('i')])])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_c('i', [_vm._v("Chapter 3")])])])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_c('i')])])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Never thought to see the day,” Thaddeus grumbled, thumping a plate of burned bacon and tomato down in front of Ransom. “Never thought to see a bastard eatin’ at me own table.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ransom swallowed the urge to take out a few more of Thaddeus’s already scarce teeth. “Mind your own affairs,” he said stiffly. “I’ll make it right.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“’Tis me affair, ye bleedin’ sod.” A cup of cloudy, lukewarm tea hit the table with a clatter. “I took care of her, I did; it’s what me an’ Theo’s done for years, all right and tight, and then you come along in your gentleman clothes and smooth talk and what’s she know about it? Ain’t never seen a blighter the likes o’ you, she ain’t. Don’t know a randy sonofabitch from a mare’s hind end—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“"), _c('i', [_vm._v("Enough.")]), _vm._v("” Ransom’s command would have frozen King George in his royal tracks. “I said I’d take care of it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cold toast rattled ominously in its rack as Thaddeus dropped it in the general vicinity of Ransom’s plate. “Spilt milk,” the old man said darkly. “I’d like to know how you’ll be cleaning it up.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’ll marry her.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Thaddeus stopped on his way to the pantry door. “Will ye now?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ransom made no answer. He bit into his charred breakfast and glared.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“When?” Thaddeus persisted.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“When I obtain a license.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Bishop Ragley’s to home, over at Barnstaple. Half an hour an’ ye can be there.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("To his utter disgust, Ransom felt himself flushing. Ragley, for God’s sake. One of his grandfather’s oldest cronies. Ransom could imagine it, confessing the sordid story to the stiff-necked cleric, asking—begging—for a special license. His gorge rose just contemplating the humiliation.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’ll ride into London and bring the license back,” he said, and then felt double disgust at the notion of explaining his intentions to a meddling servant.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Thaddeus turned and shuffled back. “That won’t do, sir. Won’t do at all.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Get on with you,” Ransom snapped. “Cursed impudence.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Cursed blackguard,” Thaddeus muttered.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ransom thrust his chair back and roared, “I’ll marry her, damn your eyes! What more do you want?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Today.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ransom stared at the old man, his jaw quivering with suppressed rage. Thaddeus stood his ground, holding out a jam-pot as if it were a knight’s shining sword. In a concerted effort to gain control of his temper, Ransom narrowed his eyes and looked down. He selected the least-crumbled piece of toast and put it on his plate. After a moment Thaddeus moved forward and spooned a blob of marmalade onto the bread.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“She’s sleepin’ like a lamb up there,” the old man said. “Like an innocent babe.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’ll speak to her when she wakes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Thaddeus plopped another spoonful of jam onto the toast. “Never knowed a mother, not as she could remember. Ain’t had no proper life at all.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I can see that,” Ransom said sourly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Sure ye can.” A third scoop of marmalade hit the mound with a liquid plunk. “Fine gentleman like yourself, knows just how to take advantage of a trustin’ lady.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ransom clamped down on a retort. Another spoonful of preserves quivered where Thaddeus dropped it and then slithered over onto the blackened bacon.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Her poor mother, that fine, gentle lady, she must be turnin’ over in her grave,” Thaddeus went on, spooning a further heap of marmalade onto the growing mound on Ransom’s plate. “And we promised her—lying there on her deathbed, she was—me and Theo promised her we’d take care of that little girl. And we done fine, too, until here comes Mr. Fancy Dancy”—preserves splattered across the bacon and dripped from the wrinkled tomato—“without a by-your-leave, all set to turn our Lady Claresta’s little girl into a wh—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“"), _c('i', [_vm._v("Don’t you say it.")]), _vm._v("” Ransom came to his feet, shoving his chair aside. In the sudden silence his words filled the air with soft menace. “If you value what’s left of your life, old man, you won’t finish that sentence.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Thaddeus drew himself up, his bald head coming no higher than two inches below Ransom’s shoulder. The manservant glared at Ransom for a long moment and then began vigorously scraping the last of the marmalade out of the pot and spooning it all over Ransom’s food. “Bullyin’ meself for your own sins,” he muttered. “Hit me, hit me, see if it makes ye feel a right one. Go on, now, while I ain’t lookin’. While me back’s turned, that’s the way. Me old neck’ll snap like a twig, I warrant. I won’t feel a thing. Won’t have to worry for me poor mistress no more, won’t have to work on me hands and knees in the garden, won’t have to—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Oh, for the love of God.” Ransom flung his tattered napkin down onto the table. “Go saddle up my horse.” He kicked the chair out of his way. “On second thought, don’t touch my horse. If your cooking skills are any example, the beast would be lame before it reached the front gate.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Where’re ye goin’?” Thaddeus asked, hope and belligerence mingled in his querulous old man’s voice.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’m going to Barnstaple. I’ll be back with the bishop this afternoon.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("From the window of her laboratory, Merlin watched him ride out of the dooryard.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("So.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He was gone.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It left a funny feeling inside her, that departure. Funny and quivery and sad, a lot like the way she had felt when Uncle Dorian had died, but worse, for this time she felt it was somehow a failure of her own, that this man who had arrived in her life like a burst of electricity had wanted to befriend her but had found her lacking. Last night he had held her in his arms, after his strange, angry laughter faded, and then when she’d awakened, he’d been gone.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She’d bathed in cold water as usual, except this time it wasn’t usual, for she’d washed away all the traces of the astonishing experience of the evening before. She’d tiptoed to the door and heard him, downstairs with Thaddeus. An odd panic drove her away when what she’d really wanted was to see him again—to touch him, to hear the laughter in his voice.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Merlin, Merlin, I love you. Do you believe me?")])])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She looked down at the leather-bound stack of papers she’d assembled. Twelve dozen, she’d counted out, and then in a burst of hope added a few extra, just in case he had more scientific friends than he had first imagined.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("But he was gone now. Merlin bit her lip and rubbed at the binding with her fingertip.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Well,")]), _vm._v(" she thought. "), _c('i', [_vm._v("Perhaps I’ll donate them to the universities")]), _vm._v(" "), _c('i', [_vm._v("myself")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The bell on the speaking box shrilled. Merlin swallowed the stupid lump in her throat. He hadn’t even taken the speaking box, in the end—the invention he had come for.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The bell rang again. Thaddeus, Merlin knew. There was no one else to call her. She sat waiting, knowing that he would give up soon. He always did. And the stairs to the solar were too much for his ancient legs.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She was safe here. She was alone with her work, as she’d always been. After the bell went silent, she slid off her stool and began to dig amidst the confusion on the table, looking for the last equations that she’d balanced before Mr. Ransom Duke had exploded into her quiet life and then faded out again.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Her dogged concentration faltered at noon, when she saw Thaddeus carry a tray for his brother across the yard to the cottage. Certain that he would be occupied for an hour with Theo, she slipped downstairs for a solitary lunch. Somehow she didn’t want to talk to Thaddeus. Not today. Not when he would ask questions. Questions like who her visitor was and why they had left the table in the middle of dinner and why the bed in Uncle Dorian’s room was mussed and why her own was not.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She frowned at the marmalade-covered breakfast plate that lay abandoned on the dining room table. There was a trail of jam across the wood that ended at a tented napkin. The napkin emitted a faint crunching sound. Merlin lifted the material. Beneath it, the hedgehog rolled up, clutching the last of a jam-covered slice of bacon.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’m not going to take it,” she assured the little animal softly. “You can open your eyes, silly.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The hedgehog ignored her. She replaced the napkin. After a moment the modest crunching resumed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Merlin sliced herself bread and cheese and sat down. All morning she’d been occupied, lost in struts and stabilizers. It had come as a profound relief to put her mind to familiar puzzles, to slide easily into the elegant world of numbers, of theories, where questions had answers, if one only thought hard enough.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Now, emerging from that comforting trance, she was aware of the silence of the empty house. Her own breathing was the loudest sound she heard. It seemed to Merlin to ache, that silence. It made her throat fill up with pointless tears.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She stared blindly at the jumble of discarded junk that filled the corners of the dining room. Leaning against the wall beneath the window was a kite she had begun months ago. The framework was there, the short tail and the smooth, silken body, carefully modeled after a hawk’s wings curved in the downbeat of flight. She knew the kite would fly. Beautifully. What she didn’t know was why.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Her gaze drifted lazily past the kite to the half-finished anemometer she’d copied from a diagram by Sir Francis Beaufort. The little twirling cups would measure wind speed. There were a pair of them—why she’d made two, she couldn’t remember, but a thought hung like a tickle at the back of her mind.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She rose. For a few minutes she stood frowning down at the kite and the anemometers. Then abruptly she grabbed them up and spread the kite across the table. After a frenzied search for tools, she bent over the kite and began to work, her mind empty of everything but her sudden purpose.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A half hour later, she was ready. The kite’s pure curve sprouted new decoration: the two anemometers, one each mounted above and below the wings, and a tall pole, salvaged from the great-hall and attached at the apex. A string was centered lower, near where a bird’s legs would have been. Half an hour of concentration had produced a pulley that would control the angle of the kite relative to the pole to Merlin’s satisfaction.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She maneuvered the unwieldy apparatus out the door and down the passage, stopping only to stuff a notebook and pencil into her apron pocket. As she stepped into the yard, a stray breeze caught the kite. The anemometers spun.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Merlin watched them, one above the other, and gave a little squeal of excitement. The wind in the dooryard gusted and died, but she knew where it would be blowing more steadily. She tucked the kite under her arm and trotted out the garden gate, headed for higher, open ground.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It was almost dark when she found her way home, dragging the pole and the kite behind her. She was utterly happy and exhausted. Her notebook was filled with observations, with every variation of wing and wind speed. She’d scribbled down equations, crossed them out and scratched in more. She’d watched the birds and with her new knowledge seen things she’d never really seen before—the arc of a soaring wing and the changing angle of a feathered curve as a buzzard came to rest in a tree. The exhilaration of discovery carried her into the dooryard and past the carriage before she even noticed it was there.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It was Ransom’s voice that broke through her reverie. She looked up and saw him striding toward her. The delight of the afternoon welled up into a cry of pure joy.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Mr. Duke,” she called. “Oh, Mr. Duke, I’ve "), _c('i', [_vm._v("done")]), _vm._v(" it! You won’t believe how simple it is! It’s the curve of the wing, you see. I have it all down. I measured everything. The wind speed varies with the curve, and the angle against the—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“"), _c('i', [_vm._v("Merlin!")]), _vm._v("” His furious shout cut her off, far louder than necessary from a yard away. He grabbed the kite and tore it out of her hands. Silk ripped under his fingers as he tossed the delicate framework aside. It landed and snapped, settling in a shapeless mass.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("His hands closed tight on Merlin’s arms, but she was looking beyond him. “You broke it,” she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Are you all right?” he demanded. “Are you hurt?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Merlin dragged her eyes away from the heap of silk and stared up at him. “You broke it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Where have you been?” he cried. “Not flying some damned kite? I’ve been out of my wits, curse you.” He began to pull her toward the house. “I come back and find your chaos of a laboratory in shambles—if the mind can conceive of such a thing—your precious Thaddeus knocked over the head, and no sign of you. I’ve got my agents out searching over half the shire.” He shook her as he walked. “You might have had your throat slit. Or worse, by God. Far worse.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Merlin stumbled along beside him, unable to focus on anything but her broken kite and his last words. “I don’t see what could be worse than that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("His grip tightened. “Don’t you? Well, let me tell you, my innocent babe, being raped—” He broke off suddenly, and even in the twilight she could see the dark rise of blood in his face. He looked sideways at her, his mouth set in a terrifying curve. “Never mind that. The bishop’s here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“The bishop,” Merlin repeated in a small voice. “What bishop?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What difference does it make? Ragley.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“But—is he here for dinner? I don’t think there’s mutton enough for…”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Lord, we won’t have him sit down to one of your elegant dinners,” the duke snapped. “He can do his business and be gone.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She pursed her lips in desperate confusion. “What business?” Then she sucked in her breath and lunged against his hand, trying to break into a run. “Not Theo! Oh, no—you can’t mean you’ve sent for a clergyman for Theo!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He stopped, so abruptly that Merlin tangled in her skirts and would have fallen if he hadn’t kept the punishing hold on her arm. “Theo is in exactly the same health as you left him. Ragley’s here to marry us, of course.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Marry us.” She shook her head. “Marry us to who?”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“"), _c('i', [_vm._v("To each other,")]), _vm._v("” he shouted.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Merlin scrunched away from him. “M-marry? But—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“It’s a little late for buts.” He pushed her through the door, and then halted in the dim-lit passage. Merlin exhaled as he let her go and stood rubbing her arms, afraid to look up at him while he was in this temper. The change from pleasure to persecution left her numb, disoriented. What had she done to make him so angry?")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("As if to further confuse her, he cupped her face and tilted it upward, bending to press his forehead against hers. “Don’t ever do that,” he said in a voice that shook, a voice far different from his earlier tone. “Merlin, don’t ever scare me like that again.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You broke my kite,” she said tremulously.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He tucked a trailing strand of dark hair behind her ear. She waited for an answer to her accusation, for a reason, but he seemed not to have heard her. His gaze had wandered downward to linger at her lips, and his fingers brushed across her cheek with a feather touch. Merlin drew in a shaky breath just an instant before his mouth closed softly on hers.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Warmth seemed to slide down over her like satin, leaving her knees feeling too tenuous to hold. She leaned on him. He supported her, held her easily against his solid shape. She could feel the muscles in his thighs grow taut. For an instant the lightning of the night before flared between them, silver-hot, and then he broke away. “I don’t think,” he whispered ruefully against her temple, “that I’ll regret this so much. I think that it might suit me very well.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Merlin dragged her heavy eyelids open. “What?” she said in a hazy voice.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He gave her a gentle push forward. “Come. The bishop’s been waiting four hours.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Their entrance to the dining room was heralded with a thump and a clang as Ransom knocked over an abandoned bellows which collapsed in a heap at his feet.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A tall, elderly man in white stockings and a black frock unfolded from his chair, but Merlin had eyes only for Thaddeus’s bald head, gleaming above a blood-stained bandage. “Thaddeus! Whatever on earth happened?” She pulled out of the duke’s grasp and rushed to the manservant. “Oh, no, did that wretched scaffolding of mine in the barn fall on you? I’m so sorry, Thaddeus, I know I promised to pull it down, and I was going to, I truly was, but you see I had a splendid notion this afternoon, and I was afraid that I’d lose what it was, you know, if I didn’t put something together just then, and—well, you see…I suppose I…just forgot.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Aye, that you did,” Thaddeus said, pushing her away as she tried to pat his shoulder. “Forgot it the last six months, you have, but that ain’t what crowned me! Some bleedin’ Frenchie, the duke here says”—he waved a hand toward Ransom—“snuck up on me like the creepy little snake he was. And I’m sorry, Miss Merlin, that I am, but he did make a wee mess of your room.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“It isn’t important now,” Ransom said sharply. “Bishop, may I present Miss Merlin Lambourne?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Merlin blinked at the thin cleric. He was observing her with a sad, faintly accusing gravity, as if she had just died and been refused admission to Heaven. She managed a curtsy—one that must have squeaked from all the rust on it, she feared.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The bishop inclined his head. “It is most gratifying to perform the Lord’s service and be of comfort to you in this moment of darkness, Miss Lambourne. I trust you will find strength in knowing that I bring His holy blessing to bestow upon your union.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Merlin made no sense of that. She glanced quickly at the duke. His mouth curved into a thin line of annoyance, but he said nothing.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“High time.” Thaddeus thumped the table and stood up, tottering only a little. “Me an’ the parson agree on that. Let’s hie on over to Theo’s room and tie the knot.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Merlin felt Ransom’s hand beneath her elbow, turning her toward the door. She set her feet frantically. “Tie the knot! Thaddeus, are you mad? You don’t really suppose I’m going to marry anyone!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Well, o’ course ye are, Miss Merlin. Why not?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She struggled for an answer. “Because I can’t. I’ve never known anyone who was married!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Well, I ’spect the duke here can tell ye all about it.” Thaddeus arched his brows. “What he ain’t managed to get across already.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ransom’s fingers tightened on her elbow. “Keep a civil tongue in your head,” he said coldly, “or you may find you don’t care for your new master.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Hmmpf. Ye can just lay them hackles, Mr. Big Dog. ’Tweren’t my doin’ she’s got to be married, no sir. And she don’t understand a word of it no how, that’s plain as a pitchfork.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The bishop cleared his throat. “Perhaps I should speak privately with Miss Lambourne. I feel that, indeed, she may not recognize the gravity of her spiritual position.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The grip on Merlin’s arm tightened until it hurt. “I hope I made myself clear, Bishop. No blame whatsoever can be attached to Miss Lambourne. Her ‘spiritual position’ is perfect innocence.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Well put, my lord duke.” The bishop fixed Ransom with a disapproving gaze. “You must certainly bear the entire weight of this incident on your own conscience. Still, as a friend of your family, and of your late grandsire, I hope you will permit me to say that Miss Lambourne might benefit from guidance—other than your own—in such a delicate situation as this.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Merlin could feel the duke’s fingers tremble and bit her lip in apprehension. For a moment she feared he would begin shouting again—there was that much rage and more in the bruising pressure of his hand. But instead he let go of her. She heard him take a deep breath and exhale it slowly. He touched her shoulder, turning her toward him, and brushed her cheek with a brief caress. “All right. I’ll be waiting, Wiz. Outside with Thaddeus.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Little good such gentle endearments had done him, Ransom thought bitterly, staring upward at the midnight shadows of the canopy. She might have been with him now, in this same bed where he’d loved her before, if Ragley hadn’t made such a cock-up of the whole thing.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He must have botched it royally, the pontificating old bumbler. Ransom could think of no other reason why he was sleeping here alone while Merlin had retired to her own bedroom, with Thaddeus to guard the door and the bishop in the next room down the hall to preserve what was left of propriety.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("And worse, for the ancient cleric to have called Ransom on the carpet—Ransom himself, by God, as if he were some common parishioner—and demand to know if he had a proper affection for this female he proposed to marry. If he "), _c('i', [_vm._v("loved")]), _vm._v(" her, for pity’s sake! The old warhorse of Westminster Abbey was lapsing into senility. Love her! How the bleeding Hell could Ransom possibly love her? He’d only laid eyes on her the day before.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Oh, he was willing to do his duty, all right. More than willing, in all honesty. He was growing tired of the inconveniences of courtesans and mistresses, of the jealousies and expenses and petty tantrums that had to be endured in order to meet his physical needs. He’d been less and less inclined to tolerate them lately, choosing to spend his time in London at Whitehall instead of at Madame’s—undoubtedly why he’d been so disgustingly susceptible to that thrice-damned aphrodisiac.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The worst of it was, Ransom was as hungry for her as he’d been under the influence of her cursed potion. He was having a devil of a time getting control of himself. In fact, he was failing utterly. He lay there burning and ready for her, and thanked God that Thaddeus and the bishop were such a pair of old maids as to insist on chaperoning her themselves. Otherwise, Ransom had a clear and humiliating knowledge of just how long he would have held out against his own desire.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He threw the bedclothes back and got up. He wanted to pace, but the hard contact of his bare toe with a carved chest effectively banished that notion. He sucked in a sharp breath and fumed at Thaddeus, who had left Ransom barely enough candle to get undressed and into bed—probably on the theory that he’d stay there more readily without a light to guide him elsewhere.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A thin shaft of moonlight poured between the curtains drawn across the bay window. Ransom pulled the musty damask aside slightly and took an exploratory look out the open casement. Ground fog filled the yard, creating a billowy floor just a foot or two below the window. It was an illusion, he knew—the distance to the pavement was undoubtedly greater than he’d like to know about—but the appearance satisfied his private discomfort. His secret fear of heights was something that he lived with—if not exactly comfortably, at least without undue agony. He had contrived to arrange his life so that the problem had faded to the status of a minor nuisance. It had been months since he’d even thought of it, and he dismissed it now, feeling only a brief twinge of uneasiness thicken in the back of his throat.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He stood with his arms spread above him, leaning on the curtain rod. A light breeze caressed his unclothed body. To his chagrin, the night air did nothing to cool the heat in his veins.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She was, he thought, the most baffling and entrancing creature he’d ever had the misfortune to meet. None of his seasoned strategies worked with her, not reason or temptation or force. Not mild force, in any event. He had no doubt he could break her if he cared to do so, but his mind passed over the possibility with distaste. Unsentimental he had to be, but only the extremity of life or death would bring him to apply that kind of pressure.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He glanced back into the dim room, unwilling to return to the suggestive depths of the great bed. With a soft grunt, he swung himself into the padded window seat, settling his back against the stone wall. The curtain fell into place, enclosing him in a cool space between the fabric and the glass.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He tilted his head back, contemplating the irony of the situation. The most eligible widower in His Majesty’s domain: rich, titled, powerful, and more than passably attractive, if his female admirers were to be believed—flatly refused, on account of a broken kite.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It should have been amusing. Ransom tried to summon a laugh, but it came out more of a snarl. The bishop had regaled her with the wages of sin and social stigma, Thaddeus had called her a bird-witted fool, and Ransom had used every appeal from sweet whispered compliments to one highly salacious kiss, which made him groan and shift restlessly just to remember. And she had taken it all with that bewildered slow blink of hers, and that fingertip resting on her full lower lip until he thought he would burn to cinders if he could not take advantage of the soft invitation.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("All for naught. She’d listened, and then turned to Ransom and asked why he’d broken her kite.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He’d made the fatal mistake, then, and still he did not know what it was. He’d apologized for the kite: he was sorry, he’d been afraid for her, it had just been a moment of clumsiness, and it was only a kite, after all, was it not? He would give her a hundred better ones.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“It was an experiment,” she’d said gravely.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“A kite?” Perhaps he’d allowed just a hint of skepticism to creep into his voice.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yes,” she said. “Now I know how to fly.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Humoring her, he’d judged it best to say nothing to that. And after a moment, giving him a long, deep look from those mist-colored eyes, which seemed unexpectedly to penetrate to the very heart of him, she’d said, “I cannot marry you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ransom clenched his jaw and leaned forward, burying his face in his arm. It was the failure that galled him. He did not like to fail, and the state of his physical passions made this debacle a particular torture. He’d not felt so hurt, so angry and ill-used, since he’d been falsely accused of stealing Latin noun declensions from his younger brother’s phrasebook.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He leaned back and closed his eyes. Lord, but he was tired and frustrated, to become as sensitive as a schoolboy over the befuddled Miss Merlin Lambourne. He tried to relax, to clear his mind, but the moment he drifted toward sleep he began to dream of Latin grammar, and of kites that tangled on the ground and would not fly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He wrenched his eyes open on a low moan. The room was quiet. Outside, the moon had set. The fog had risen, blotting out the night sky. He nodded off again, this time to a nightmare of flying, on a kite that took him ever higher, horrifyingly high, so high that he could not even imagine the ground, until suddenly the kite dissolved and he began to fall—his worst fear, his personal terror—and he had no breath to scream, no hope—")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He came awake in a shivering sweat. The diamond-shaped windowpanes were cool and hard against his face. He lay against the glass and metal network, holding his breath while his heart thudded in his ears. At first the other noise seemed part of that, only a distant echo of the sound of his own night fear. He exhaled slowly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("As he took his first conscious breath, his mind and body snapped to full awareness. He froze. The pounding of his blood rang in his head, but it could not conceal the sound he heard.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Footsteps.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There was someone else in the room, and the still air was laden with the smell of ether."), _c('b', [_c('i', [_c('span', {
    staticClass: "Apple-converted-space"
  })])])])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_c('i')])])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_c('i')])])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_c('i')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23ab6361","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section4.vue
// module id = 72
// module chunks = 0